<template>
   <div>
    <ul v-show="parseInt(clipartItems.active)">
        <li class="clipartItem cmpt" v-for="index in  parseInt(clipartItems.items.length/2)" @click="changeClipartBackground(clipartItems.items[index-1])" :class="[{ active: parseInt(clipartItems.items[index-1].active) }]">
            <div @mouseover="mouseOver(clipartItems.items[index-1])" @mouseleave="mouseLeave(clipartItems.items[index-1])" v-bind:style="{'background-image': 'url('+clipartItems.items[index-1].secondUrl+')' }">
              <span class="no-icon" v-if="parseInt(clipartItems.items[index-1].no_icon)">{{strings.noIcon}}</span>
            </div>
        </li>
    </ul>
       <ul v-show="parseInt(clipartItems.active)">
        <li class="clipartItem cmpt" v-for="index in parseInt(clipartItems.items.length/2)" @click="changeClipartBackground(clipartItems.items[index-1+parseInt(clipartItems.items.length/2)])" :class="[{ active: parseInt(clipartItems.items[index-1+parseInt(clipartItems.items.length/2)].active) }]">
            <div @mouseover="mouseOver(clipartItems.items[index-1+parseInt(clipartItems.items.length/2)])" @mouseleave="mouseLeave(clipartItems.items[index-1+parseInt(clipartItems.items.length/2)])" v-bind:style="{'background-image': 'url('+clipartItems.items[index-1+parseInt(clipartItems.items.length/2)].secondUrl+')' }">

            </div>
        </li>
    </ul>
   </div>
</template>
<script>
    export default {
        props   : ['clipartItems', 'label'],
        data(){
            return {
                strings:this.$store.getters.strings
            }
        },
        methods : {
            changeClipartBackground ( clipartItem ) {
                var lines = JSON.stringify( this.label.lines );
                $jQuery( ".previewMessage"+this.label.uniqueId ).hide();
             var params = {
                    labelId     : this.label.id,
                    clipartItem : clipartItem
                }
                this.label.cliparts.forEach( function( element ) {
                    element.items.forEach( function( item ) {
                        item.active = 0;
                        item.secondUrl = item.url;
                    } )
                } );
                clipartItem.active = 1;
               this.label.isReady = 0;
                clipartItem.secondUrl = this.$store.getters.strings.getSvgUrl + "?category=" + clipartItem.category + "&filename=" + clipartItem.filename + "&color=234,141,0";
                this.$store.dispatch( 'changeClipart', params );
                   if( parseInt(this.label.labelUseClipartItem)) {

                       if ( parseInt( this.label.use_icon ) ) {
                           var code = this.label.default_format;
                            if(product_id == '215'){
                                if(code == 'one_line') {
                                    code = 'default_171';
                                }else{
                                     code = 'default_172';
                                }
                            }
                            if(product_id == '162'){
                                if(code == 'one_line') {
                                    code = 'default_185';
                                }else{
                                     code = 'default_186';
                                }
                            }if( [404, 420, 406, 407, 423, 407, 424].indexOf( (parseInt( product_id )) ) > -1){
                                if(code == 'one_line') {
                                    code = 'default_172';
                                }else{
                                     code = 'default_172';
                                }
                            }
                            if(this.label.default_format == "one_line" || this.label.default_format == "two_lines"){
                                code = this.label.default_format;
                            }else {
                                var i = 0;
                                this.label.lines.forEach( function( line ) {
                                    if ( !parseInt( line.masterBlock ) ) {
                                        i++;
                                    }
                                } );
                                if( i == 1){
                                    code ="one_line";
                                }
                                if(i == 2){
                                    code="two_lines";
                                }
                            }
                           // code ="one_line";
                           if ( typeof(this.label.formats_icons) != "undefined" && typeof(this.label.formats_icons[code]) != "undefined" ) {
                               // this.label.lines = this._O( this.label.formats_icons[code].lines, this.label.lines );
                              //  this.label.lines =  JSON.parse(JSON.stringify(this.label.formats_icons[code].lines));
                               this.label.formats_icons[code].lines.forEach((function(_this){
                                   return function(element,index){
                                       if(typeof ( _this.label.lines[index]) !="undefined") {
                                           _this.label.lines[index]['width'] = element.width;
                                           _this.label.lines[index]['height'] = element.height;
                                           _this.label.lines[index]['left'] = element.left;
                                           _this.label.lines[index]['top'] = element.top;
                                           _this.label.lines[index]['page_resize_percentageW'] = element.page_resize_percentageW;
                                           _this.label.lines[index]['page_resize_percentageH'] = element.page_resize_percentageH;
                                           _this.label.lines[index]['page_width'] = element.page_width;
                                           _this.label.lines[index]['pdf_width'] = element.pdf_width;
                                           _this.label.lines[index]['real_width'] = element.real_width;
                                           _this.label.lines[index]['real_height'] = element.real_height;
                                           _this.label.lines[index]['pdf_height'] = element.pdf_height;
                                       }
                                   }
                               })(this));

                               this.label.backgrounds = this._O( this.label.formats_icons[code].backgrounds, this.label.backgrounds );
                               this.label.cliparts_blocks = JSON.parse(JSON.stringify(this.label.formats_icons[code].cliparts_blocks));
                               this.label.back_images = this.label.formats_icons[code].back_images;
                               this.label.width = this.label.formats_icons[code].width
                               this.label.height = this.label.formats_icons[code].height;
                               this.label.code = this.label.formats_icons[code].code;
                               this.label.image = this.label.formats_icons[code].image;
                               this.label.templateid = this.label.formats_icons[code].templateid;
                               this.label.code = this.label.formats_icons[code].code;
                               this.$store.dispatch( 'changeClipart', params );
                           }
                       }
                       else {
                           var code = this.label.default_format;
                           if ( typeof (this.label.formats[code]) != "undefined" ) {

                               this.label.backgrounds = this._O( this.label.formats[code].backgrounds, this.label.backgrounds );

                               if ( [215, 162, 404, 420, 406, 407, 423, 407, 424].indexOf( (parseInt( product_id )) ) > -1) {

                                   this.label.cliparts_blocks = [];
                                        this.label.formats[code].lines.forEach((function(_this){
                                   return function(element,index){
                                        var block  = _this.label.lines.find(line=>line.id==element.id);
                                       if(typeof ( block) !="undefined") {
                                          block['width'] = element.width;
                                          block['height'] = element.height;
                                          block['left'] = element.left;
                                         block['top'] = element.top;
                                          block['page_resize_percentageW'] = element.page_resize_percentageW;
                                          block['page_resize_percentageH'] = element.page_resize_percentageH;
                                           block['page_width'] = element.page_width;
                                         block['pdf_width'] = element.pdf_width;
                                          block['real_width'] = element.real_width;
                                          block['real_height'] = element.real_height;
                                          block['pdf_height'] = element.pdf_height;
                                       }
                                   }
                               })(this));
                               }else{
                                   this.label.lines = this._O( this.label.formats[code].lines, this.label.lines );
                                   this.label.cliparts_blocks = JSON.parse(JSON.stringify(this.label.formats[code].cliparts_blocks, this.label.cliparts_blocks ));
                               }
                                 this.label.backgrounds = this._O( this.label.formats[code].backgrounds, this.label.backgrounds );
                               this.label.back_images = this.label.formats[code].back_images;
                               this.label.width = this.label.formats[code].width
                               this.label.height = this.label.formats[code].height;
                               this.label.code = this.label.formats[code].code;
                               this.label.image = this.label.formats[code].image;
                               this.label.templateid = this.label.formats[code].templateid;
                               this.label.code = this.label.formats[code].code;
                           }
                       }
                        setTimeout((function(_this,params){
                            return function(){
                                    const x = {
                           record      : _this.label,
                           backColorId : _this.label.current_color
                       }
                        //        jQuery('.previewMessage').show();
                                _this.$store.dispatch( 'changeBackgroundColor', x );
                                _this.$store.dispatch( 'setMasterText', {labelId : _this.label.id} );
                                _this.$store.dispatch( 'changeClipart', params );
                                store.dispatch( 'initPage', {label : _this.label} );
                              _this.label.isReady = 1;
                            }
                        })( this, params ), 200 )

                   }
                   else{
                       this.label.isReady =1;
                   }

                   setTimeout((function(_this,lines){
                       JSON.parse( lines ).forEach( (function( instance ) {
                           return function(  line, index ) {
                                if(!parseInt(line.masterBlock))
                               if ( line.text.length != instance.label.lines[index].text.length ) {
                                   $jQuery( ".previewMessage"+instance.label.uniqueId ).show();
                               }
                           }
                       })( _this ) )
                   })(this,lines),300)

            },
            mouseOver ( clipart ) {
                var img = new Image();
                var secondUrl = this.$store.getters.strings.getSvgUrl + "?category=" + clipart.category + "&filename=" + clipart.filename + "&color=234,141,0";
                // img.onload = function() {
                clipart.secondUrl = secondUrl;
                //}
                img.src = secondUrl;
            },
            mouseLeave ( clipart ) {
                if ( ! parseInt(clipart.active) ) {
                    clipart.secondUrl = clipart.url;
                }
            },
             _O: function (o,defaults) {
                var d = $jQuery.extend(true, {}, d);
                return $jQuery.extend(true, defaults, o);
            },
        }
    }
</script>
<style>
.clipartItem {
    display       : flex;
    margin        : 0 9px 13px 0;
    padding       : 5px;
    height        : 80px;
    border-radius : 10px;
    background    : #F9F9F9;
    box-shadow    : 0 3px 0 0 rgba(0, 0, 0, 0.14);
    padding       : 11px 5px 4px;
    min-height    : 50px;
    text-align    : center;
    border        : solid 2px #F9F9F9;
    width         : 72px;
    float         : left;
    flex          : 2;
    border        : solid 2px transparent;
    cursor        : pointer;
    min-width:72px;
}

.clipartItem div {
    position            : relative;
    top                 : 50%;
    left                : 50%;
    transform           : translate(-50%, -50%);
    width               : 67px;
    height              : 67px;
    background-size     : contain;
    background-repeat   : no-repeat;
    background-position : center center;
}

.clipartItem.active,
.clipartItem:hover {
    border : solid 2px #EA8D00;
    color: #EA8D00;
}

.allCliparts ul {
    width     : 100%;
    height    : 90px;
    max-width : 99999999999px;
    display   : inline-block;
    float     : left;
    display   : flex;
}

.allCliparts {
    width      : 100%;
    height     : auto;
    float      : left;
    overflow   : auto;
    height     : 193px;
    overflow-y : hidden;
}
    .no-icon{
            line-height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cliparts/Cliparts.vue